import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderToggler,
  CImage
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilMenu } from '@coreui/icons'

// Component
import AppBreadcrumb from './AppBreadcrumb'
import AppHeaderDropdown from './header/AppHeaderDropdown'

// Icons
import CloudxierIcon from '../assets/icons/CloudxierLogoInWhite.png'

const AppHeader = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)

  return (
    <CHeader position="sticky" className="mb-4 header-app">
      <CContainer fluid className="header-app-bar">
        <CHeaderToggler
          className="header-app-toggler"
          onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <CHeaderBrand className="mx-auto d-md-none header-brand" to="/">
          <CImage src={CloudxierIcon} className="header-brand-logo" />
        </CHeaderBrand>
        <div className="header-app-breadcrumb">
          <AppBreadcrumb />
        </div>
        <AppHeaderDropdown />
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
